import React from 'react'
import Header from '../../shared/header'
import AvailableUnit from '../../components/availability/availableUnit'
import PagesFooter from "../../shared/pagesFooter"
const AvailabilityPage = () => {
    return (
        <div>
            <div className='availability-header '>
                <Header />
            </div>
            <AvailableUnit />
            <PagesFooter />

        </div>
    )
}

export default AvailabilityPage